import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { CtnReportLegend, CtnReportSection, CtnReportTooltip } from "./CtnReportChartParts";
import { reportColor } from "./reportUtils";

export const CtnDistributionChart = ({ id, title, label, rows, filters }) => {
  const total = rows.reduce((sum, row) => sum + row.stuks, 0);
  return <CtnReportSection id={id} title={title} label={label} rows={rows} filters={filters}>
    <div className="ctn-distribution-layout">
      <div className="ctn-distribution-chart" role="img" aria-label={`${title}: ${rows.length} groepen, ${total} stuks`} data-testid={`ctn-report-chart-${id}`}>
        <ResponsiveContainer width="100%" height="100%" minWidth={0} initialDimension={{ width: 330, height: 290 }}>
          <PieChart>
            <Pie data={rows} dataKey="stuks" nameKey="naam" cx="50%" cy="50%" outerRadius="85%" startAngle={90} endAngle={-270} stroke="#fff" strokeWidth={1.5} isAnimationActive={false}>
              {rows.map((row, i) => <Cell key={row.naam} fill={reportColor(i)} data-testid={`ctn-report-slice-${id}-${i}`} />)}
            </Pie>
            <Tooltip content={<CtnReportTooltip id={id} total={total} />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <CtnReportLegend rows={rows} id={id} total={total} />
    </div>
  </CtnReportSection>;
};